import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class WizardPropsBuilder extends PropsBuilder<'wizard'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { container: { visualEffect } } });
    return this;
  };
}
